import React, { useState } from 'react';
import { 
  Building2, 
  MapPin, 
  Mail, 
  Phone, 
  MessageSquare, 
  Info, 
  Globe 
} from 'lucide-react';
import { useNotifications } from '../context/NotificationContext';
import './PublicSettings.css';

const PublicSettings = () => {
  const { addNotification } = useNotifications();
  const [formData, setFormData] = useState({
    clinicName: 'GESTION DE TURNOS',
    address: 'Bartolome Mitre 854, CABA',
    email: 'info@gestionamientodeturnos.com',
    phone: '1125565076',
    whatsapp: 'Sin Indicar',
    extraInfo: 'NO RESPONDA ESTE MAIL',
    country: 'Argentina'
  });

  const handleUpdate = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleSave = () => {
    addNotification('Cambios guardados correctamente.', 'success');
  };

  const fields = [
    { 
      id: 'clinicName', 
      label: 'Nombre del Consultorio que verán los Pacientes', 
      icon: Building2, 
      value: formData.clinicName 
    },
    { 
      id: 'address', 
      label: 'Dirección que verán los Pacientes', 
      icon: MapPin, 
      value: formData.address 
    },
    { 
      id: 'email', 
      label: 'Email que verán los Pacientes', 
      icon: Mail, 
      value: formData.email 
    },
    { 
      id: 'phone', 
      label: 'Teléfonos que verán los Pacientes', 
      icon: Phone, 
      value: formData.phone 
    },
    { 
      id: 'whatsapp', 
      label: 'Nro. de Whatsapp al que sus Pacientes puedan responderle', 
      icon: MessageSquare, 
      value: formData.whatsapp 
    },
    { 
      id: 'extraInfo', 
      label: 'Datos Extra que verán los Pacientes', 
      icon: Info, 
      value: formData.extraInfo 
    },
    { 
      id: 'country', 
      label: 'País', 
      icon: Globe, 
      value: formData.country 
    }
  ];

  return (
    <div className="public-settings-page">
      <div className="settings-panel card">
        <h1 className="settings-title">Datos que ven los Pacientes</h1>
        <p className="settings-description">
          Estos datos los verán los pacientes en los Emails de recordatorios/confirmación de turno, y en el Portal de Autogestión.
        </p>

        <div className="settings-fields-list">
          {fields.map(field => (
            <div key={field.id} className="settings-field-item">
              <div className="field-icon-wrapper">
                <field.icon size={22} className="field-icon" />
              </div>
              <div className="field-content">
                <label className="field-label">{field.label}</label>
                <input 
                  type="text" 
                  className="field-input"
                  value={field.value}
                  onChange={(e) => handleUpdate(field.id, e.target.value)}
                />
              </div>
            </div>
          ))}
        </div>

        <div className="settings-footer">
          <button className="btn-save-settings" onClick={handleSave}>
            GUARDAR CAMBIOS
          </button>
        </div>
      </div>
    </div>
  );
};

export default PublicSettings;
